import React from 'react';
import { CapabilityStatement } from '../components/CapabilityStatement';
import { FileCheck, ShieldAlert, Award, Briefcase, ShieldCheck } from 'lucide-react';
export function EntityData() {
  return <div className="bg-white" data-id="element-393">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-394">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-395">
          <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-4" data-id="element-396">
            Entity Data & Compliance
          </h1>
        </div>
      </div>

      <CapabilityStatement data-id="element-397" />

      <section className="py-16 bg-white" data-id="element-398">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-399">
          <div className="grid md:grid-cols-2 gap-16" data-id="element-400">
            <div data-id="element-401">
              <h3 className="text-xl font-black text-federal-blue uppercase tracking-widest mb-8 flex items-center gap-2" data-id="element-402">
                <Briefcase className="w-5 h-5 text-muted-gold" data-id="element-403" />
                Contract Vehicles
              </h3>
              <div className="space-y-4" data-id="element-404">
                {[{
                name: 'GSA Multiple Award Schedule (MAS)',
                code: 'GS-35F-XXXXX'
              }, {
                name: '8(a) STARS III (In Progress)',
                code: 'Pending'
              }, {
                name: 'SeaPort-NxG',
                code: 'N00178-XX-D-XXXX'
              }].map((vehicle, i) => <div key={i} className="flex justify-between items-center p-4 bg-slate-50 border border-slate-200 rounded-sm" data-id="element-405">
                    <span className="font-bold text-tech-slate text-sm" data-id="element-406">
                      {vehicle.name}
                    </span>
                    <span className="text-[10px] font-black bg-federal-blue text-white px-2 py-1 rounded uppercase" data-id="element-407">
                      {vehicle.code}
                    </span>
                  </div>)}
              </div>
            </div>
            <div data-id="element-408">
              <h3 className="text-xl font-black text-federal-blue uppercase tracking-widest mb-8 flex items-center gap-2" data-id="element-409">
                <Award className="w-5 h-5 text-muted-gold" data-id="element-410" />
                Quality Assurance
              </h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-411">
                <div className="p-4 border border-slate-200 rounded-sm text-center" data-id="element-412">
                  <FileCheck className="w-8 h-8 text-federal-blue mx-auto mb-2" data-id="element-413" />
                  <p className="text-[10px] font-black uppercase text-tech-slate" data-id="element-414">
                    ISO 9001:2015
                  </p>
                </div>
                <div className="p-4 border border-slate-200 rounded-sm text-center" data-id="element-415">
                  <ShieldAlert className="w-8 h-8 text-federal-blue mx-auto mb-2" data-id="element-416" />
                  <p className="text-[10px] font-black uppercase text-tech-slate" data-id="element-417">
                    ISO 27001
                  </p>
                </div>
                <div className="p-4 border border-slate-200 rounded-sm text-center" data-id="element-418">
                  <ShieldCheck className="w-8 h-8 text-federal-blue mx-auto mb-2" data-id="element-419" />
                  <p className="text-[10px] font-black uppercase text-tech-slate" data-id="element-420">
                    CMMI Level 3
                  </p>
                </div>
                <div className="p-4 border border-slate-200 rounded-sm text-center" data-id="element-421">
                  <Award className="w-8 h-8 text-federal-blue mx-auto mb-2" data-id="element-422" />
                  <p className="text-[10px] font-black uppercase text-tech-slate" data-id="element-423">
                    NIST 800-171
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}